<template>
        <div class="form-group field">
            <label for="img">{{ label }}</label>
            <div class="control">
                <div v-if="!showInput">
                    <input type="hidden" name="image_keep" value="true" />
                    <img :src="'/media/blogg/' + image" />
                    <button v-on:click="showInput=true">{{ remove }}</button>
                </div>
                <div v-else>
                    <input type="hidden" name="image_keep" value="false" />
                    <input
                        class="input form-control btn input-group-btn"
                        type="file"
                        name="img"
                        id="img"
                    >
                </div>
            </div>

        </div>

</template>

<script>

export default {

    data() {
        return this.initialState();
    },

    props: {
        old : String,
        label : String,
        remove : String

    },

    mounted() {
        this.image = this.old;
        this.showInput = this.old.length ? false : true;
    },

    methods: {
        initialState: function(){
            return {
                image : null,
                showInput : false
            }
        }

    }
};
</script>
